import './nextButton.css';
import './roundButton.css';
import './roundButtonSmall.css';
import './squareButton.css';
import './checkButton.css';
import './squareAnswerButton.css';

export default function Button({
    type,
    action,
    text,
    background = '',
    disabled = false,
}) {
    return (
        <button
            disabled={disabled}
            className={type}
            onClick={action}
            style={{ background: background }}>
            <p>{text}</p>
        </button>
    );
}
